import { z } from 'zod';
import { IngestProtocol } from './streaming.enums';

export const PlaybackTokenResponseSchema = z.object({
  token: z.string(),
  playbackUrl: z.url(),
  expiresAt: z.iso.datetime(),
});

export const IngestCredentialsResponseSchema = z.object({
  ingestEndpoint: z.url(),
  streamKey: z.string(),
  protocol: z.enum(IngestProtocol),
});

export const TelemetryReportRequestSchema = z.object({
  eventId: z.uuid(),
  viewerCount: z.number().optional(),
  rebufferRate: z.number().optional(),
  bitrateKbps: z.number().optional(),
  latencyMs: z.number().optional(),
  playbackErrorRate: z.number().optional(),
  deviceType: z.string().optional(),
  region: z.string().optional(),
});
